
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.02 10.99V18C19.02 18.55 18.57 19 18.02 19H6.00002C5.45002 19 5.00002 18.55 5.00002 18V6C5.00002 5.45 5.45002 5 6.00002 5H13C13.55 5 14 4.55 14 4C14 3.45 13.55 3 13 3H5.02002C3.92002 3 3.02002 3.9 3.02002 5V19C3.02002 20.1 3.92002 21 5.02002 21H19C20.1 21 21 20.11 21 19V10.99C21 10.44 20.56 10 20.01 10C19.46 10 19.02 10.44 19.02 10.99ZM13.25 10.75L12.46 9C12.28 8.61 11.73 8.61 11.55 9L10.76 10.75L9.00002 11.54C8.61002 11.72 8.61002 12.27 9.00002 12.45L10.75 13.24L11.54 15C11.72 15.39 12.27 15.39 12.45 15L13.24 13.25L15 12.46C15.39 12.28 15.39 11.73 15 11.55L13.25 10.75ZM17.94 6.06L17.34 4.74C17.21 4.45 16.79 4.45 16.65 4.74L16.05 6.06L14.73 6.66C14.44 6.79 14.44 7.21 14.73 7.35L16.05 7.95L16.65 9.27C16.78 9.56 17.2 9.56 17.34 9.27L17.94 7.95L19.26 7.35C19.55 7.22 19.55 6.8 19.26 6.66L17.94 6.06Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-photo-filter`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPhotoFilter

    ```js
    <b-new-b-icon-photo-filter />
    ```
</docs>


